import { useTranslation } from 'react-i18next';
import SelectAutocomplete from '../../../../select-autocomplete';
import { ILocationFilter } from './interfaces/ILocationFilter';

export default function LocationFilter({
    title,
    federativeUnitId,
    federativeUnitLabel,
    federativeUnitValue,
    federativeUnitOptions,
    onFederativeUnitChange,
    descriptionId,
    descriptionLabel,
    descriptionValue,
    descriptionOptions,
    onDescriptionChange,
    onDescriptionSearch,
    onDescriptionFetchDataResults,
}: Readonly<ILocationFilter>) {
    const { t } = useTranslation();

    return (
        <>
            <h3>{t(title)}</h3>
            <SelectAutocomplete
                id={federativeUnitId}
                mode="multiple"
                label={t(federativeUnitLabel)}
                value={federativeUnitValue}
                onChange={onFederativeUnitChange}
                placeholder={t('DigitePesquisar')}
                options={federativeUnitOptions}
                maxTagCount="responsive"
                data-testid={federativeUnitId}
                notFoundContent={t('NaoHaDadosParaExibir')}
            />
            <SelectAutocomplete
                id={descriptionId}
                mode="multiple"
                label={t(descriptionLabel)}
                value={descriptionValue}
                onChange={onDescriptionChange}
                placeholder={t('DigitePesquisar')}
                options={descriptionOptions}
                onSearch={onDescriptionSearch}
                onFetchDataResults={onDescriptionFetchDataResults}
                maxTagCount="responsive"
                data-testid={descriptionId}
                notFoundContent={t('NaoHaDadosParaExibir')}
            />
        </>
    );
}
